import './i18n'
import { createRouter } from '@tanstack/react-router'
import { createIsomorphicFn } from '@tanstack/react-start'
import { routeTree } from './routeTree.gen'

const createAppRouter = () =>
  createRouter({ routeTree, scrollRestoration: true })

let routerSingleton: ReturnType<typeof createAppRouter> | null = null

export const getRouter = createIsomorphicFn()
  .server(() => createAppRouter())
  .client(() => {
    routerSingleton ??= createAppRouter()
    return routerSingleton
  })

export type AppRouter = ReturnType<typeof getRouter>

declare module '@tanstack/react-router' {
  interface Register {
    router: AppRouter
  }
}
